// i18n
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

export const supportedLocales = [
	'am-ET',
	'bn-BD',
	'en-US',
	'es-ES',
	'fil-PH',
	'fr-FR',
	'ja-JP',
	'pt-PT',
	'ro-RO',
	'sw-KE',
	'zh-CN',
];

export const supportedLngs = supportedLocales.map((locale) => {
	return locale.split('-')[0];
});

i18n
	.use(Backend)
	.use(initReactI18next)
	.init({
		fallbackLng: 'en',
		interpolation: {
			escapeValue: false,
		},
		lng: sessionStorage.getItem('language') || 'en',
		supportedLngs,
	});

export default i18n;
